<template>
  <div class="settings_block">
    <div class="settings" v-for="(setting, setting_key) in new_settings" :key="setting_key">
      <p class="title">
        {{ setting_key }}
      </p>
      <div class="params">


        <div
          class="param"
           v-for="(value, key) in setting"
           :key="setting_key + key"
        >

          <div class="form-group" v-if="value.type !== 'boolean'">
            <label :for="value.key">
              {{ value.key }}
            </label>
            <input
              class="form-control border-input"
              v-model="value.value"
              :placeholder="value.key"
              :id="value.key"
            >
          </div>

          <div class="filter checkbox" v-else>
            <div class="info">
              {{ value.key }}
            </div>
            <label class="switch" @click.prevent="value.value = !value.value">
              <input type="checkbox" v-model="value.value">
              <span class="slider round"></span>
            </label>
          </div>

        </div>
      </div>
    </div>
    <div class="line" v-if="changes">
      <div class="button_wrap">
        <button
            class="btn btn-success btn-fill btn-wd"
            @click.prevent="update_profile"
        >
          {{ translate("btn.edit")}}
        </button>
      </div>
    </div>

  </div>
</template>
<script>

export default {
  name: "UserSettings",
  props: ["user_id", "settings"],
  data () {
    return {
      disabled_btn: false,
      new_settings: {}
    }
  },
  created() {
    this.new_settings = JSON.parse(JSON.stringify(this.settings))
  },
  computed:{
    changes(){
      return JSON.stringify(this.settings) !== JSON.stringify(this.new_settings)
    },
  },
  watch:{
    settings(){
      this.new_settings = JSON.parse(JSON.stringify(this.settings))
    }
  },
  methods: {
    cancel () {
      this.$emit('close')
    },
    update_profile(){
      let settings = JSON.parse(JSON.stringify(this.new_settings))

      for (let block in settings) {
        for (let param in settings[block]) {
          if (settings[block][param].type === 'number'){
            settings[block][param].value = Number(settings[block][param].value)
          }
          delete settings[block][param].type
        }
      }

      this.$http.v1.updateUserSettings(settings, (response) => {
        this.global_notify('info', "Settings updated")
        this.$emit('update_setting', response.data)
      })
    }
  }
}

</script>
<style lang='scss' scoped>
  .settings{
    padding: 10px;
    margin-bottom: 10px;
    .title{
      text-align: center;
      text-transform: uppercase;
      margin: 0;
    }
    .params{
      display: flex;
      align-items: flex-start;
      justify-content: flex-start;
      flex-wrap: wrap;
      .param{
        width: 50%;
        margin: 5px;
        text-align: left;

        .filter{
          flex-direction: row;
          justify-content: space-between;
          .info{
            color: #252422;
            font-weight: bold;
          }
        }

        .form-group{
          margin: 0;
          display: flex;
          justify-content: space-between;
          align-items: center;
          .form-control{
            width: 50%;
          }
        }
      }
    }
  }

</style>
